export default {
  dateTime:
    'Указать дату и время возникновения проблемы либо первого уведомления о проблеме',
  link: 'Вставить ссылку на инцидент  в Jira',
  resolutionDate: 'Указать дату и время решения проблемы',
  maxAppVersion:
    'Ввести нижнюю и/либо верхнюю границу версии приложения, в которых выявлена проблема',
  techTag: 'Описывает техническую суть возникшей проблемы',
  classTag: 'Описывает группу, к которой относится возникший инцидент',
  typeTag:
    'Oписывает, где или, в чём конкретно заключается проблема (слот, акция, фича...)',
};
